import Vue from "vue";
import App from "./App";
import { router } from "./router";
import store from "../src/store";

import Vuetify from "vuetify";
import VueMq from "vue-mq";
import "vuetify/dist/vuetify.min.css";
import "font-awesome/css/font-awesome.css";

import "material-design-icons-iconfont/dist/material-design-icons.css";

import axios from "axios";
import VueAxios from "vue-axios";

import fullCalendar from "vue-fullcalendar";
import { setupComponents } from "./config/setup-components";

import { baseBackUrl, baseFrontUrl } from "./assets/linkTree";

import swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css";

//graficas
import Chartkick from "vue-chartkick";
import Chart from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import accessibility from "highcharts/modules/accessibility";
import annotation from "highcharts/modules/annotations";
annotation(Chart);
exportingInit(Chart);
accessibility(Chart);
// Chart.plugins.register(ChartAnnotationsPlugin);
var chartOptions = {
  lang: {
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    shortMonths: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    weekdays: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ],
    downloadCSV: "Descarga CSV",
    downloadJPEG: "Descarga JPEG",
    downloadPDF: "Descarga PDF",
    downloadPNG: "Descarga PNG",
    downloadSVG: "Descarga SVG",
    downloadXLS: "Descarga XLS",
    exitFullscreen: "Salir de pantalla completa",
    viewFullscreen: "Ver en pantalla completa",
    printChart: "Imprimir Gráfico",
    loading: "Cargando...",
    noData: "No hay datos para mostrar"
  },
  legend: {
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
  },
  accessibility: {
    enabled: true
  }
};
Chart.setOptions(chartOptions);

Vue.use(Chartkick.use(Chart));

Vue.use(VueAxios, axios);
Vue.component("full-calendar", fullCalendar);
Vue.component("swatches", swatches);

const opts = {};
Vue.use(Vuetify);

Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 1285,
    desktop: Infinity
  }
});
setupComponents(Vue);

var screenLoad = false;
Vue.config.productionTip = false;

import Vuex from "vuex";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App),
  data: {
    themeColor: "#004283"
  },
  computed: {
    $mmsi: {
      get: Vuex.mapState(["$mmsi"]).$mmsi,
      set: Vuex.mapMutations(["update$mmsi"]).update$mmsi
    }
  }
}).$mount("#app");

Vue.prototype.$screenLoad = screenLoad;
Vue.prototype.$baseBackUrl = baseBackUrl;
Vue.prototype.$baseFrontUrl = baseFrontUrl;



// WEBPACK FOOTER //
// ./src/main.js